import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';

// Constants
import { ROUTE_PATHS } from '../../constants/routes';

// Types
import { IStore } from '../../store/Store';

// Utilities
import { required, between, email } from '../../utilities/validation';

// Components
import Box from '../../components/Box';
import Button from '../../components/Button';
import { AlertDialog } from '../../components/Dialog';
import { EntryLayout } from '../../components/Layout';
import Grid from '../../components/Grid';
import {
  Form,
  TextField,
  LabelCheckbox
} from '../../components/FormStateFields';
import Link from '../../components/Link';
import Typography from '../../components/Typography';

// FormState
class LoginForm {
  username = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(5, 100), email);
  password = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(4, 32));
  remember = new FieldState(true);

  state = new FormState({
    username: this.username,
    password: this.password,
    remember: this.remember
  });

  gerValues() {
    return {
      username: this.username.$,
      password: this.password.$,
      remember: this.remember.$
    };
  }
}

// Component
interface IProps {
  store?: IStore;
}
class Login extends React.Component<IProps, {}> {
  form = new LoginForm();

  @observable
  alertDialogState = {
    open: false,
    title: 'Wrong email or password',
    description: 'Please try again or contact support.'
  };

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const validation = await this.form.state.validate();

    if (validation.hasError === false) {
      try {
        await this.props.store!.meStore!.login(this.form.gerValues());
        this.props.store!.routerStore!.navigate(`${ROUTE_PATHS.APP}`);
      } catch (error) {
        this.alertDialogState.open = true;
      }
    }
  };

  handleErrorDialogClose = () => {
    this.alertDialogState.open = false;
  };

  render() {
    return (
      <EntryLayout>
        <Box pa={5}>
          <Typography type="headline">Login</Typography>
          <Typography type="body1" color="textSecondary">
            Share Knowledge &amp; Discover More
          </Typography>
          <Form onSubmit={this.handleSubmit}>
            <TextField
              label="Email"
              type="email"
              fieldState={this.form.username}
              margin="normal"
              fullWidth={true}
            />
            <TextField
              label="Password"
              type="password"
              fieldState={this.form.password}
              margin="normal"
              fullWidth={true}
            />
            <br />
            <br />
            <Grid container={true} justify="space-between" alignItems="center">
              <Grid item={true}>
                <LabelCheckbox
                  label="Remember"
                  fieldState={this.form.remember}
                />
              </Grid>
              <Grid item={true}>
                <Link routeName={ROUTE_PATHS.FORGOT} className="HyperLink">
                  <span style={{ fontSize: '0.875rem' }}>Forgot password?</span>
                </Link>
              </Grid>
            </Grid>
            <br />
            <Button
              raised={true}
              color="primary"
              fullWidth={true}
              type="submit"
            >
              Log In
            </Button>
            <Box pt={3}>
              <Typography type="body1" align="center" color="textSecondary">
                Dont have an account?{' '}
                <Link routeName={ROUTE_PATHS.SIGN_UP} className="HyperLink">
                  Create new
                </Link>
              </Typography>
            </Box>
          </Form>
        </Box>
        <AlertDialog
          state={this.alertDialogState}
          onClose={this.handleErrorDialogClose}
          onConfirm={this.handleErrorDialogClose}
        />
      </EntryLayout>
    );
  }
}

export default inject('store')(observer(Login));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Login/Login.tsx